import { render, staticRenderFns } from "./crossSettlement.vue?vue&type=template&id=93f93b78&scoped=true"
import script from "./crossSettlement.vue?vue&type=script&lang=js"
export * from "./crossSettlement.vue?vue&type=script&lang=js"
import style0 from "./crossSettlement.vue?vue&type=style&index=0&id=93f93b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f93b78",
  null
  
)

export default component.exports